import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightToLine } from '@fortawesome/pro-solid-svg-icons';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';
import { _js } from '@ifixit/localize';

export const GridAddColumnButton = () => {
   const { editor } = useEditorContext();

   if (editor.isDestroyed) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().increaseColumns().run()}
         isDisabled={!editor.can().increaseColumns()}
         icon={<FontAwesomeIcon icon={faRightToLine} />}
         title={_js('Add column')}
      />
   );
};
